import { render, staticRenderFns } from "./inspectScreen.vue?vue&type=template&id=62990e87&scoped=true"
import script from "./inspectScreen.vue?vue&type=script&lang=js"
export * from "./inspectScreen.vue?vue&type=script&lang=js"
import style0 from "./inspectScreen.vue?vue&type=style&index=0&id=62990e87&prod&lang=scss&scoped=true"
import style1 from "./inspectScreen.vue?vue&type=style&index=1&id=62990e87&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62990e87",
  null
  
)

export default component.exports